import { render } from "./inputCurrency.vue?vue&type=template&id=25051856"
import script from "./inputCurrency.vue?vue&type=script&lang=js"
export * from "./inputCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__